<template>
  <div>
    <div class="row justify-content-center space-top-1 space-bottom-2 px-3">
      <div>
        <h3>FAQ</h3>

        <div role="tablist" class="space-top-1">
          <ol class="faq">
            <li
              v-for="(faq, index) in questions"
              :key="index"
              :index="index"
              :question="faq.question"
              :answer="faq.answer"
            >
              <Card
                :key="index"
                :index="index"
                :question="faq.question"
                :answer="faq.answer"
              />
            </li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Card from "./Card.vue";
import questions from "./faq.json";

export default {
  name: "FAQ",
  components: {
    Card
  },
  mounted() {
    this.$gtag.event("LabFAQ");
  },
  data() {
    return {
      questions
    };
  }
};
</script>
